var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenommer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6811",
    "data-name": "Groupe 6811",
    transform: "translate(0 -78.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6811-2",
    "data-name": "Groupe 6811",
    transform: "translate(0 80.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9645",
    "data-name": "Trac\\xE9 9645",
    d: "M2.336,143.609H1.012v-3.541H2.336v-1.012H1.012A1.012,1.012,0,0,0,0,140.069v3.541a1.012,1.012,0,0,0,1.012,1.012H2.336Z",
    transform: "translate(0 -139.057)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9646",
    "data-name": "Trac\\xE9 9646",
    d: "M190.35,139.057h-6.775v1.012h6.775v3.541h-6.775v1.012h6.775a1.012,1.012,0,0,0,1.012-1.012v-3.541A1.012,1.012,0,0,0,190.35,139.057Z",
    transform: "translate(-179.362 -139.057)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9647",
    "data-name": "Trac\\xE9 9647",
    d: "M75.876,86.939l-1.013-.5V80.149l1.013-.5a.314.314,0,0,0,.14-.4l-.119-.276a.278.278,0,0,0-.377-.15l-1.084.531-1.084-.531a.278.278,0,0,0-.377.15l-.119.276a.314.314,0,0,0,.14.4l1.013.5v6.294l-1.013.5a.314.314,0,0,0-.14.4l.119.276a.278.278,0,0,0,.377.15l1.084-.531,1.084.531a.278.278,0,0,0,.377-.15l.119-.276A.314.314,0,0,0,75.876,86.939Z",
    transform: "translate(-71.104)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6812",
    "data-name": "Groupe 6812",
    transform: "translate(5.4 83.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9648",
    "data-name": "Trac\\xE9 9648",
    d: "M197.1,246.045a.364.364,0,0,1,.37-.388.389.389,0,1,1-.37.388Z",
    transform: "translate(-197.095 -245.657)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9649",
    "data-name": "Trac\\xE9 9649",
    d: "M250.911,246.045a.364.364,0,0,1,.37-.388.389.389,0,1,1-.37.388Z",
    transform: "translate(-249.635 -245.657)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9650",
    "data-name": "Trac\\xE9 9650",
    d: "M304.728,246.045a.364.364,0,0,1,.37-.388.389.389,0,1,1-.37.388Z",
    transform: "translate(-302.176 -245.657)",
    fill: "#b5b5b5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenommer);
export default __webpack_public_path__ + "static/media/Renommer.599877803d74b38136ba19ffd914ccfc.svg";
export { ForwardRef as ReactComponent };